<template>
    <div>
       <YxHead />
       <div class="index-center">
         <div class="index-head">
           <el-input v-model="search" placeholder="请输入内容" style="width:400px;" suffix-icon="el-icon-search"></el-input>
         </div>
         <div class="index-middle">
           <div class="index-middle-center" :style="mideelHeight">
               <div class="index-middle-center-sc">
                   <!-- <img src="../assets/collect.png" alt=""> -->
                   <img src="../assets/cancel.png" alt="">
               </div>
               <img src="http://47.119.141.79/mic/static/img/login-background.68680005.jpg" alt="">
               <p class="index-middle-cente-title">测试App</p>
           </div> 
           <div class="index-middle-center">
               
           </div>
           <div class="index-middle-center">
               
           </div>  
           <div class="index-middle-center">
               
           </div> 
           <div class="index-middle-center">
               
           </div> 
           <div class="index-middle-center">
               
           </div> 
           <div class="index-middle-center">
               
           </div> 
           <div class="index-middle-center">
               
           </div>
           
         </div>
       </div>
    </div>
</template>
<script>
import YxHead from "@/components/YxHead.vue"
export default {
    components:{
         YxHead
    },
    data() {
        return{
            search:undefined,
            mideelHeight:{
                height:undefined
            }
        }
    },
    mounted(){
        this.initHeight()
    },
    methods:{
        initHeight(){
          var div= document.getElementsByClassName('index-middle-center')
          if(div){
              this.mideelHeight.height = div[0].clientWidth + 'px'
 
          }
        }
    }
}
</script>
<style lang="scss" scoped>
  ::v-deep .index-center{
      background-image: url('../assets/index.png');
      background-size: 100% 100%;
      width: 100%;
      height: calc(100vh - 70px);
    //   opacity: 0.5;
      display: flex;
      justify-content: center;
      flex-flow: column;
      align-items: center;
      .index-head{
 
          display: flex;
          justify-content: center;
          .el-input__inner{
              color: #000;
              height:50px !important;
              font-size:18px !important;
         
          }
      }
      .el-icon-search{
          font-size: 20px;
          line-height: 50px;
          color: #000 !important;
          font-weight: 700 !important;

      }
      .index-middle{
          display: flex;
          justify-content:left;
           flex-wrap:wrap;
          margin-top: 50px;
          width: 75%;
          height: calc(100vh - 300px);
          align-content:flex-start;
        //   background:red;
          .index-middle-center{
              
              margin-left: 4%;
              width: 20%;
            //   height: 200px;
              background: #FFFFFF;
              border-radius: 20px;
              margin-bottom: 50px;
              display: flex;
              justify-content: center;
              flex-flow: column;
              align-items: center;
              position: relative;
              img{
                  width: 60%;
                  height: 60%;
                  border-radius: 50%;
                //   margin-top: -20%;
              }
              .index-middle-cente-title{
                  font-size: 18px;
                  color: #666;
              }
              .index-middle-center-sc{
                
                  img{
                      top: 10px;
                      right: 10px;
                      position: absolute;
                      width: 40px;
                      height: 40px;
                      cursor: pointer;
                  }
              }
          }
      }
  }
</style>